<template>
  <section>
    <div v-if="isVisible" class="modal">
      <!-- Modal content goes here -->
      <div class="modal-content" ref="modalContent">
        <span class="close" @click="closeModal" @click.stop>&times;</span>

        <div class="modal-header">
          <slot name="header"><h3>Edit User Profile</h3></slot>
        </div>

        <div class="modal-body">
          <slot name="body">
            <div class="row gutters">
              <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="card h-100">
                  <div class="card-body user-profile">
                    <div class="row gutters">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                      ></div>
                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group">
                          <label for="fullName">Full Name</label>
                          <input
                            v-model="state.vu_fname"
                            type="text"
                            class="form-control"
                            id="fullName"
                            placeholder="Enter full name"
                            v-bind:class="{
                              invaliddata: v$.vu_fname.$error == true,
                            }"
                          />
                          <span v-if="v$.vu_fname.$error">
                            {{ v$.vu_fname.$errors[0].$message }}
                          </span>
                        </div>
                      </div>

                      <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12">
                        <div class="form-group">
                          <label for="dob">Updage Image</label>

                          <div class="clear"></div>
                          <img
                            v-if="previewImage == ''"
                            :src="'../../public/img/team/team-1.jpg'"
                            class="img-thumbnail rounded-circle"
                            alt="Service"
                            style="height: 65px; width: 65px"
                          />

                          <img
                            v-if="previewImage !== ''"
                            :src="previewImage"
                            class="img-thumbnail rounded-circle"
                            alt="Service"
                            style="
                              height: 65px;
                              width: 65px;
                              margin-right: 15px;
                            "
                          />
                          <i
                            class="fas fa-camera"
                            @click="$refs.imageFile.click()"
                          ></i>
                          <input
                            class="ml"
                            type="file"
                            accept="image/jpeg"
                            @change="uploadImage"
                            ref="imageFile"
                            style="display: none"
                          />
                        </div>
                      </div>
                    </div>

                    <div class="row gutters">
                      <div
                        class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                      >
                        <div class="button-area">
                          <div class="rightbtn">
                            <button
                              type="button"
                              id="submit02"
                              name="submit"
                              class="btn puprple_btn aos-init aos-animate"
                              data-aos="fade-in"
                              data-aos-duration="1500"
                              @click="cancelModal"
                            >
                              Cancel
                            </button>
                          </div>
                          <div class="leftbtn">
                            <button
                              type="button"
                              id="submit"
                              name="submit"
                              class="btn puprple_btn aos-init aos-animate"
                              data-aos="fade-in"
                              data-aos-duration="1500"
                              @click="submitForm()"
                            >
                              Update<span></span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </slot>
        </div>

        <div class="modal-footer"></div>
      </div>
    </div>
  </section>
</template>

<script>
import useVuelidate from "@vuelidate/core";
import { required, minLength } from "@vuelidate/validators";
import { reactive, computed } from "vue";
import { mapActions, mapGetters } from "vuex";
import { toast } from "vue3-toastify";
import gsap from "gsap";
export default {
  name: "UserProfileEditor",
  props: {
    isVisible: true,
  },
  setup() {
    const state = reactive({
      vu_fname: "",
      //vu_email: "",
      //vu_phone: "",
      //vu_date: "",
    });

    const rules = computed(() => {
      return {
        vu_fname: { required, minLength: minLength(3) },
        //vu_email: { required, email },
        //vu_phone: { required, numeric },
        // vu_date: { required, minLength: minLength(3) },
      };
    });

    const v$ = useVuelidate(rules, state);
    return {
      state,
      v$,
    };
  },
  data() {
    return {
      userId: "",
      previewImage: "",
      phone: "",
    };
  },
  computed: {
    ...mapGetters(["getCurrentUser"]),
  },

  methods: {
    closeModal() {
      this.zoomOut();
    },

    ...mapActions(["updateUserProfileAction"]),
    submitForm() {
      this.v$
        .$validate()
        .then(() => {
          if (!this.v$.$error) {
            this.parentCloseModal();
          }
        })
        .catch((error) => {
          alert("form failed validation");
          console.log(error);
        });
    },

    parentCloseModal() {
      this.callApiforSendingData();
    },
    async callApiforSendingData() {
      try {
        console.log("Hellos");
        const formData01 = new FormData();
        formData01.append("id", this.userId);
        formData01.append("name", this.state.vu_fname);
        // formData01.append("email", this.state.vu_email);
        // formData01.append("phone", this.phone);
        if (this.$refs.imageFile.files[0]) {
          formData01.append("image", this.$refs.imageFile.files[0]);
        }

        let response = await this.updateUserProfileAction(formData01);
        console.log(response, "Response");
        if (response.status == 200) {
          this.$emit("userDate");
          toast.success(response.data.message, {
            position: toast.POSITION.TOP_RIGHT,
            timeout: 5000,
            duration: 5000,
            closeOnClick: true,
            pauseOnFocusLoss: true,
            pauseOnHover: true,
            draggable: true,
            draggablePercent: 0.6,
            showCloseButtonOnHover: false,
            hideProgressBar: false,
            closeButton: true,
            icon: true,
            rtl: false,
          });
        }

        this.zoomOut();
      } catch (error) {
        this.error = error.response;
      }
    },
    cancelModal() {
      this.zoomOut();
    },

    zoomIn() {
      gsap.set(this.$refs.modalContent, { scale: 0 });
      gsap.to(this.$refs.modalContent, {
        scale: 1,
        duration: 0.5,
        ease: "power2.out",
      });
    },
    zoomOut() {
      gsap.to(this.$refs.modalContent, {
        scale: 0.5,
        opacity: 0,
        duration: 0.5,
        ease: "power2.in",
        //onComplete: () => this.$emit("close"),
        onComplete: this.onZoomOutComplete,
      });
      //this.$emit("close");
    },
    userInfo() {
      // let user_data = JSON.parse(this.getCurrentUser);
      console.log("i am in info");
      // let user_data = this.getCurrentUser;
      let user_data = localStorage.getItem("user");

      let userData = JSON.parse(user_data);
      this.state.vu_fname = userData.name;
      this.state.vu_email = userData.email;
      this.state.vu_phone = userData.phone;
      this.userId = userData.id;
      this.previewImage =
        "https://saltbucket1.s3.us-east-2.amazonaws.com/" + userData.image;
      //console.log(this.getCurrentUser.name, "UserName");
    },
    uploadImage(e) {
      const image = e.target.files[0];
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (e) => {
        this.previewImage = e.target.result;
        console.log(this.previewImage);
      };
    },
    onZoomOutComplete() {
      // After the closing animation completes, emit the close event
      this.$emit("close");
    },
  },

  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.$nextTick(() => this.zoomIn());
        //this.zoomIn();
      } else {
        this.zoomOut();
      }
    },
  },
  mounted() {
    this.userInfo();
  },
};
</script>

<style scoped>
.modal {
  position: fixed;
  z-index: 9999999999999;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgba(0, 0, 0, 0.4);
  display: block;
  color: #d73000;
}

.modal h3 {
  color: #d73000;
}

.modal-content {
  background-color: #000000;
  margin: 15% auto;
  padding: 20px;
  border: 1px solid #d73000;
  width: 40%;
}

.modal .modal-header {
  border-bottom: 1px solid #d73000;
  width: 100%;
}
.modal .card {
  background-color: #222;
}
.modal .form-group input {
  background: transparent;
  border: solid 1px #d73000;
  color: #fff;
}
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  text-align: right;
  cursor: pointer;
}

.rightbtn {
  float: right;
}
.card-body .fas {
  font-size: 26px;
  cursor: pointer;
}
.modal-footer{
  border-top:solid 1px #d73000
}
</style>
